/* Multimax 29 años | Landing aniversario (page.aniversario-29)
   Hero en carrusel con logo animado, Venta exclusiva por fecha, carruseles de producto, carrito y footer.
   Cada sección mx29-* carga este archivo; la guarda evita que se ejecute dos veces. */
(function () {
  if (window.MX29) return;
  window.MX29 = { version: 2 };

  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ───── Venta exclusiva: horario en hora de la tienda ─────
     Cada día empieza en su fecha a la hora data-mx29-start (9:00 a.m.) y termina al día siguiente a la hora data-mx29-end (8:00 a.m.).
     data-mx29-tz trae el desfase de la tienda ('-0500' en Panamá), así el estado no depende de la zona del visitante. */
  const DAY = 864e5;
  const parseYmd = (s) => { const m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((s || '').trim()); return m ? [+m[1], +m[2], +m[3]] : null; };
  const tzMin = (v) => { const m = /^([+-])(\d{2})(\d{2})$/.exec(v || ''); return m ? (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]) : -300; };
  const at = (ymd, tz, addDays, h, mi) => Date.UTC(ymd[0], ymd[1] - 1, ymd[2] + addDays, h, mi) - tz * 60000;
  const hourTxt = (h) => (h === 0 ? '12 A.M.' : h < 12 ? h + ' A.M.' : h === 12 ? '12 P.M.' : h - 12 + ' P.M.');
  const fmtMoney = (c) => '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fmtShort = (ymd) => new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2])).toLocaleDateString('es-PA', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).replace(/[.,]/g, '');
  /* Ventana de un día: { ymd, tz, endH, start, mid (medianoche del día siguiente), end } */
  const hour = (v, def) => (v !== undefined && v !== '' && Number.isFinite(+v) ? +v : def);
  function excDay(dateStr, tzStr, startH, endH) {
    const ymd = parseYmd(dateStr); if (!ymd) return null;
    const tz = tzMin(tzStr), s = hour(startH, 9), e = hour(endH, 8);
    return { ymd, tz, endH: e, start: at(ymd, tz, 0, s, 0), mid: at(ymd, tz, 1, 0, 0), end: at(ymd, tz, 1, e, 0) };
  }
  const excState = (w, now = Date.now()) => (now < w.start ? 'next' : now < w.end ? 'today' : 'past');
  function setStatus(el, w) {
    const now = Date.now(), st = excState(w, now);
    let txt = 'FINALIZÓ';
    if (st === 'today') txt = now >= w.mid ? 'HASTA LAS ' + hourTxt(w.endH) : 'HOY';
    else if (st === 'next') {
      const t = new Date(now + w.tz * 60000), today = Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate());
      const n = Math.round((Date.UTC(w.ymd[0], w.ymd[1] - 1, w.ymd[2]) - today) / DAY);
      txt = n <= 0 ? 'HOY' : n === 1 ? 'MAÑANA' : 'EN ' + n + ' DÍAS';
    }
    el.textContent = txt;
    el.className = 'xst' + (st === 'next' ? '' : ' ' + st);
  }

  /* ───── Swipe horizontal ───── */
  function onSwipe(el, cb) {
    let x0 = null;
    el.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
    el.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 50) cb(dx < 0 ? 1 : -1); });
  }

  /* ───── Logo 29 años animado (PNG en capas) ─────
     0–2 s plateado con destellos · 2–5 s ola holográfica y pasa a azul · 4.8–6.7 s un cometa dibuja la órbita · destello en la estrella */
  const LG = { cx: 984.47, cy: 479.16, a: 268.16, b: 967.68, phi: 1.18636, ts: 5.32997, W: 1958, H: 1084 };
  function logoAnim(wrap) {
    const stage = wrap.querySelector('.la-stage'), imgs = [...wrap.querySelectorAll('.la-base,.la-orbit')], orb = wrap.querySelector('.la-orbit'),
      sweep = wrap.querySelector('.la-sweep'), comet = wrap.querySelector('.la-comet'), sp = [...wrap.querySelectorAll('.la-spark')];
    const pt = (t) => [LG.cx + LG.a * Math.cos(t) * Math.cos(LG.phi) - LG.b * Math.sin(t) * Math.sin(LG.phi), LG.cy + LG.a * Math.cos(t) * Math.sin(LG.phi) + LG.b * Math.sin(t) * Math.cos(LG.phi)];
    const polar = ([x, y]) => ((Math.atan2(x - LG.cx, -(y - LG.cy)) * 180) / Math.PI + 360) % 360;
    const start = polar(pt(LG.ts)), C = `${((LG.cx / LG.W) * 100).toFixed(2)}% ${((LG.cy / LG.H) * 100).toFixed(2)}%`;
    const setMask = (deg) => { const v = deg >= 359.9 ? 'none' : deg <= 0 ? 'linear-gradient(transparent,transparent)' : `conic-gradient(from ${start}deg at ${C},#000 0deg,#000 ${deg}deg,transparent ${deg + 2}deg)`; orb.style.webkitMaskImage = v; orb.style.maskImage = v; };
    const cl = (x) => Math.min(1, Math.max(0, x)), ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2), env = (x, s, d) => { const u = (x - s) / d; return u <= 0 || u >= 1 ? 0 : Math.sin(Math.PI * u); };
    const pop = (el, v) => { el.style.opacity = v; el.style.transform = `translate(-50%,-50%) scale(${v}) rotate(${v * 45}deg)`; };
    const END = 7.6;
    let t0 = 0, raf = 0, endCb = null, ended = false;
    if (reduced()) { setMask(360); return null; }
    function frame(now) {
      const tt = (now - t0) / 1000;
      const e = ease(cl(tt / 0.8)); stage.style.opacity = e; stage.style.transform = `scale(${0.93 + 0.07 * e})`;
      const g = 1 - ease(cl((tt - 2) / 2.6)); imgs.forEach((i) => (i.style.filter = g > 0.001 ? `grayscale(${g}) brightness(${1 + 0.14 * g}) contrast(${1 + 0.06 * g})` : 'none'));
      let sw = 0, pos = 100;
      if (tt < 5.6) { const u = cl((tt - 2) / 3.2); sw = env(tt, 2, 3.4) * 0.95; pos = 100 - u * 100; }
      else if (tt > END) { const c = (tt - END) % 6; if (c < 1.8) { sw = Math.sin((Math.PI * c) / 1.8) * 0.55; pos = 100 - (c / 1.8) * 100; } }
      sweep.style.opacity = sw; sweep.style.backgroundPosition = `${pos}% 0`;
      if (tt < 4.8) { setMask(0); comet.style.opacity = 0; }
      else if (tt < 6.7) {
        const u = ease(cl((tt - 4.8) / 1.9)), p = pt(LG.ts + u * 2 * Math.PI);
        let d = (polar(p) - start + 360) % 360; if (u > 0.5 && d < 5) d = 360; if (u < 0.02) d = 0; setMask(d);
        comet.style.left = (p[0] / LG.W) * 100 + '%'; comet.style.top = (p[1] / LG.H) * 100 + '%'; pop(comet, Math.min(1, u * 8, (1 - u) * 8 + 0.2));
      } else { setMask(360); pop(comet, 0); }
      pop(sp[0], Math.max(env(tt, 0.4, 0.9), env(tt, 3.1, 0.8), tt > END ? env((tt - END) % 6, 3.2, 0.8) : 0));
      pop(sp[1], Math.max(env(tt, 1.2, 0.9), env(tt, 4.1, 0.8)));
      pop(sp[2], Math.max(env(tt, 6.5, 1), tt > END ? env((tt - END) % 6, 2.4, 0.9) : 0) * 1.1);
      if (!ended && tt >= END) { ended = true; if (endCb) { const f = endCb; endCb = null; f(); } }
      raf = requestAnimationFrame(frame);
    }
    return {
      restart() { cancelAnimationFrame(raf); t0 = performance.now(); ended = false; endCb = null; raf = requestAnimationFrame(frame); },
      stop() { cancelAnimationFrame(raf); endCb = null; },
      onEnd(cb) { if (ended) cb(); else endCb = cb; },
    };
  }

  /* ───── Hero ───── */
  function initHero(hero) {
    if (hero.__mx29) return; hero.__mx29 = true;
    const slides = [...hero.querySelectorAll('.slide')], ui = hero.querySelector('.hero-ui');
    if (!slides.length) { hero.hidden = true; return; }
    hero.querySelectorAll('.slide[data-mx29-date]').forEach((s) => {
      const w = excDay(s.dataset.mx29Date, s.dataset.mx29Tz, s.dataset.mx29Start, s.dataset.mx29End), st = s.querySelector('[data-mx29-status]');
      if (w && st) { setStatus(st, w); setInterval(() => setStatus(st, w), 60000); }
    });
    // "Ver productos" del banner de venta exclusiva abre ese día en la sección
    hero.querySelectorAll('.slide[data-mx29-date] .xcta').forEach((a) => a.addEventListener('click', () => {
      const exc = document.querySelector('[data-mx29-exc]'); if (exc && exc.mx29Select) exc.mx29Select(a.closest('.slide').dataset.mx29Date);
    }));

    const logoWrap = hero.querySelector('.logo-anim'), logo = logoWrap ? logoAnim(logoWrap) : null;
    const logoSlide = logoWrap ? logoWrap.closest('.slide') : null;
    const interval = +hero.dataset.interval || 7000;
    let i = 0, timer = 0, paused = false;
    slides[0].classList.add('on');
    if (logo && slides[0] === logoSlide) logo.restart();

    const arrows = hero.querySelectorAll('.arrow');
    if (slides.length < 2) { arrows.forEach((a) => (a.hidden = true)); ui.hidden = true; return; }

    ui.innerHTML = slides.map((_, k) => `<button type="button" class="dot${k ? '' : ' on'}" role="tab" aria-label="Banner ${k + 1}"></button>`).join('');
    const dots = [...ui.children];
    const go = (k) => {
      slides[i].classList.remove('on'); dots[i].classList.remove('on');
      if (logo && slides[i] === logoSlide) logo.stop();
      i = (k + slides.length) % slides.length;
      slides[i].classList.add('on'); dots[i].classList.add('on');
      if (logo && slides[i] === logoSlide) logo.restart();
    };
    const auto = () => {
      clearTimeout(timer); if (paused || reduced()) return;
      const next = () => { go(i + 1); auto(); };
      if (logo && slides[i] === logoSlide) {
        // el banner del logo espera a que termine la animación y luce la órbita 3 s
        timer = setTimeout(next, 16000);
        logo.onEnd(() => { if (paused) return; clearTimeout(timer); timer = setTimeout(next, 3000); });
      } else timer = setTimeout(next, interval);
    };
    dots.forEach((d, k) => (d.onclick = () => { go(k); auto(); }));
    hero.querySelector('.arrow.prev').onclick = () => { go(i - 1); auto(); };
    hero.querySelector('.arrow.next').onclick = () => { go(i + 1); auto(); };
    onSwipe(hero, (dir) => { go(i + dir); auto(); });
    hero.addEventListener('mouseenter', () => { paused = true; clearTimeout(timer); });
    hero.addEventListener('mouseleave', () => { paused = false; auto(); });
    hero.__mx29stop = () => { paused = true; clearTimeout(timer); if (logo) logo.stop(); };
    auto();
  }

  /* ───── Tarjetas de la Venta exclusiva (carrusel y cuadrícula "Promociones del día") ───── */
  // Botón de compra según el estado del día (solo se compra durante la venta)
  function setBtn(b, st, w) {
    if (!b.dataset.label) b.dataset.label = b.textContent;
    b.classList.remove('soon', 'done');
    if (st === 'today' && b.hasAttribute('data-mx29-soldout')) { b.disabled = true; b.classList.add('done'); b.textContent = 'Agotado'; }
    else if (st === 'today') { b.disabled = false; b.textContent = b.dataset.label; }
    else if (st === 'next') { b.disabled = true; b.classList.add('soon'); b.textContent = w ? 'Disponible el ' + fmtShort(w.ymd) : 'Próximamente'; }
    else { b.disabled = true; b.classList.add('done'); b.textContent = 'Venta finalizada'; }
  }

  // Durante el evento: precio y disponibilidad reales del producto en Shopify (no los cargados a mano).
  // getState() devuelve el estado actual del día al terminar la consulta.
  function livePrices(container, getState, w) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    container.querySelectorAll('.xpc[data-mx29-handle]').forEach(async (card) => {
      if (card.__mx29live) return; card.__mx29live = true;
      try {
        const r = await fetch(root + 'products/' + encodeURIComponent(card.dataset.mx29Handle) + '.js', { cache: 'no-store' });
        if (!r.ok) throw new Error(r.status);
        const prod = await r.json(), v = prod.variants.find((x) => x.available) || prod.variants[0]; if (!v) return;
        const cmp = v.compare_at_price || 0, onSale = cmp > v.price;
        if (card.dataset.mx29Promo === '2x1') {
          // 2 x 1: se mantiene "2 x 1" y el precio pasa a ser el real
          const reg = card.querySelector('.price .reg'); if (reg) reg.textContent = fmtMoney(v.price);
        } else {
          card.querySelector('.price b').textContent = fmtMoney(v.price);
          const s = card.querySelector('.price s'); if (s) { s.textContent = fmtMoney(cmp); s.hidden = !onSale; }
          const sv = card.querySelector('.save'); if (sv) { sv.textContent = 'Ahorra ' + fmtMoney(Math.round((cmp - v.price) / 100) * 100); sv.hidden = !onSale; }
        }
        const b = card.querySelector('.add[data-mx29-add]');
        if (b) { b.dataset.mx29Add = v.id; b.toggleAttribute('data-mx29-soldout', !v.available); setBtn(b, getState(), w); }
      } catch (_) { card.__mx29live = false; } // se reintenta en el próximo cambio de estado
    });
  }

  /* ───── Promociones del día (cuadrícula, una sección por día) ─────
     Se muestra solo la del día elegido en la Venta exclusiva y con las mismas reglas que su carrusel. */
  function initGrid(g) {
    if (g.__mx29) return; g.__mx29 = true;
    const root = g.closest('.mx29-lp'), count = g.querySelectorAll('.xpc').length;
    g.mx29Count = count;
    g.mx29Sync = (date, show, st, w) => {
      const mine = count > 0 && (g.dataset.mx29Date || '').trim() === date;
      root.hidden = !(mine && show);
      if (!mine) return;
      g.querySelectorAll('.add[data-mx29-add],.add[data-mx29-href]').forEach((b) => setBtn(b, st, w));
      if (st === 'today') livePrices(g, () => g.__mx29st || st, w);
      g.__mx29st = st;
    };
  }

  /* ───── Venta exclusiva en el frontpage (sección mx29-home-exclusivas) ─────
     Lee la sección Venta exclusiva de la landing y muestra los destacados del día en curso o del próximo. */
  const fmtParts = (ymd) => {
    const d = new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2])), o = { timeZone: 'UTC' };
    return { wd: d.toLocaleDateString('es-PA', { ...o, weekday: 'short' }).replace('.', ''), d: ymd[2], m: d.toLocaleDateString('es-PA', { ...o, month: 'short' }).replace('.', '').toUpperCase() };
  };
  async function loadLandingExc(url, fixedId) {
    const key = 'mx29-exc-id:' + url, store = (() => { try { return window.localStorage; } catch (_) { return null; } })();
    let id = fixedId || (store && store.getItem(key));
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mx29-exc]');
    if (id) {
      try {
        const j = await fetch(url + (url.includes('?') ? '&' : '?') + 'sections=' + encodeURIComponent(id)).then((r) => r.json());
        if (j && j[id]) { const sec = parse(j[id]); if (sec) return sec; }
      } catch (_) {}
    }
    // Sin id (o id viejo): se descarga la landing una vez y se guarda el id de la sección para las próximas visitas
    const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
    const doc = new DOMParser().parseFromString(html, 'text/html'), sec = doc.querySelector('[data-mx29-exc]');
    const wrap = sec && sec.closest('[id^="shopify-section-"]');
    if (wrap && store) { try { store.setItem(key, wrap.id.replace('shopify-section-', '')); } catch (_) {} }
    return sec;
  }
  async function initHome(root) {
    if (root.__mx29) return; root.__mx29 = true;
    const note = root.parentElement && root.parentElement.querySelector('[data-mx29-home-note]');
    const loaded = () => { root.classList.remove('is-loading'); root.removeAttribute('aria-busy'); };
    const fail = () => { loaded(); root.hidden = true; if (note && window.Shopify && Shopify.designMode) note.hidden = false; };
    let src;
    try { src = await loadLandingExc(root.dataset.url || '/pages/aniversario', (root.dataset.sectionId || '').trim()); } catch (_) { src = null; }
    if (!src) return fail();
    const slides = [...src.querySelectorAll('.xs')], panels = [...src.querySelectorAll('.xpanel')], tabs = [...src.querySelectorAll('.xtab')];
    const days = slides.map((s) => excDay(s.dataset.mx29Date, src.dataset.mx29Tz, s.dataset.mx29Start || src.dataset.mx29Start, src.dataset.mx29End));
    const track = root.querySelector('[data-mx29-home-track]'), empty = root.querySelector('[data-mx29-home-empty]'), box = root.querySelector('.xcd');
    const more = root.querySelector('.xh-more'), baseMore = more.getAttribute('href');
    let cur = -1, st = '';

    // Día a mostrar: el que está en curso; si no hay, el próximo en empezar
    const pick = (now) => {
      let k = days.findIndex((w) => w && excState(w, now) === 'today');
      if (k < 0) days.forEach((w, j) => { if (w && excState(w, now) === 'next' && (k < 0 || w.start < days[k].start)) k = j; });
      return k;
    };
    function render(k) {
      cur = k; const w = days[k], p = fmtParts(w.ymd);
      root.querySelector('[data-mx29-wd]').textContent = p.wd; root.querySelector('[data-mx29-d]').textContent = p.d; root.querySelector('[data-mx29-m]').textContent = p.m;
      const suc = tabs[k] ? tabs[k].querySelector('span').textContent.trim() : '';
      root.querySelector('[data-mx29-sub]').textContent = (suc ? 'Web + ' + suc + ' · ' : '') + fmtShort(w.ymd);
      const cards = panels[k] ? [...panels[k].querySelectorAll('.xpc')] : [];
      track.innerHTML = ''; cards.forEach((c) => track.appendChild(document.importNode(c, true)));
      track.scrollLeft = 0; empty.hidden = cards.length > 0; root.querySelector('.xh-track-wrap').hidden = !cards.length;
      more.href = baseMore; st = '';
      root.hidden = false; loaded(); if (note) note.hidden = true;
    }
    function tick() {
      const now = Date.now(), k = pick(now);
      if (k < 0) { clearInterval(root.__mx29timer); return fail(); }
      if (k !== cur) render(k);
      const w = days[cur], s = excState(w, now);
      if (s !== st) {
        st = s;
        track.querySelectorAll('.add[data-mx29-add],.add[data-mx29-href]').forEach((b) => setBtn(b, s, w));
        if (s === 'today') livePrices(track, () => st, w);
        box.classList.toggle('live', s === 'today');
        box.querySelector('.xcd-l').textContent = s === 'today' ? 'Termina en' : 'Empieza en';
      }
      const left = Math.max(0, Math.floor(((s === 'today' ? w.end : w.start) - now) / 1000));
      const v = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
      box.querySelectorAll('.xcd-n i').forEach((el, j) => { const t = String(v[j]).padStart(2, '0'); if (el.textContent !== t) el.textContent = t; });
      box.setAttribute('aria-label', `${box.querySelector('.xcd-l').textContent} ${v[0]} días, ${v[1]} horas y ${v[2]} minutos`);
    }
    root.querySelector('.xh-arrow.prev').onclick = () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
    root.querySelector('.xh-arrow.next').onclick = () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    tick();
    root.__mx29timer = setInterval(tick, 1000);
  }

  /* ───── Venta exclusiva ───── */
  function initExc(sec) {
    if (sec.__mx29) return; sec.__mx29 = true;
    const slides = [...sec.querySelectorAll('.xs')], tabs = [...sec.querySelectorAll('.xtab')], panels = [...sec.querySelectorAll('.xpanel')];
    const n = slides.length; if (!n) return;
    const days = slides.map((s) => excDay(s.dataset.mx29Date, sec.dataset.mx29Tz, s.dataset.mx29Start || sec.dataset.mx29Start, sec.dataset.mx29End));
    const stateOf = (k, now) => (days[k] ? excState(days[k], now) : 'next');
    let sts = [], sel;
    const canShow = [];

    // Estado de cada día: etiquetas, pestañas, botones y qué días muestran productos
    function applyStates() {
      const now = Date.now();
      sts = days.map((_, k) => stateOf(k, now));
      // El próximo día (el que empieza antes entre los que no han empezado) muestra sus productos por adelantado
      let nearest = -1;
      sts.forEach((st, k) => { if (st === 'next' && days[k] && (nearest < 0 || days[k].start < days[nearest].start)) nearest = k; });
      slides.forEach((s, k) => { const el = s.querySelector('[data-mx29-status]'); if (el && days[k]) setStatus(el, days[k]); });
      tabs.forEach((b, k) => { b.classList.remove('next', 'today', 'past'); b.classList.add(sts[k]); const hoy = b.querySelector('i'); if (hoy) hoy.hidden = sts[k] !== 'today'; });
      panels.forEach((p, k) => {
        // Productos visibles: el día en curso, el próximo y los terminados; los días más adelante no
        canShow[k] = sts[k] !== 'next' || k === nearest;
        const track = p.querySelector('.track-wrap'), empty = p.querySelector('.mx29-empty');
        const show = !!p.querySelector('.xpc') && canShow[k];
        if (track) track.hidden = !show;
        if (empty) {
          // Día terminado sin productos en el carrusel (se quitan para no pasar el límite de 50 bloques)
          if (!empty.dataset.soon) empty.dataset.soon = empty.textContent;
          empty.textContent = sts[k] === 'past' ? 'Esta venta ya terminó.' : empty.dataset.soon;
          empty.hidden = show;
        }
        p.querySelectorAll('.add[data-mx29-add],.add[data-mx29-href]').forEach((b) => setBtn(b, sts[k], days[k]));
        if (sts[k] === 'today') livePrices(p, () => sts[k], days[k]);
      });
      if (typeof sel === 'number') syncGrids();
    }

    // Cuadrícula "Promociones del día" del día elegido y botón "Ver las N promociones" del panel
    function syncGrids() {
      const date = (slides[sel].dataset.mx29Date || '').trim(), grids = [...document.querySelectorAll('[data-mx29-grid]')];
      grids.forEach((g) => g.mx29Sync && g.mx29Sync(date, canShow[sel], sts[sel], days[sel]));
      panels.forEach((p, k) => {
        const a = p.querySelector('.xall'); if (!a) return;
        const g = k === sel && canShow[k] && grids.find((x) => x.mx29Count > 0 && (x.dataset.mx29Date || '').trim() === date);
        a.hidden = !g;
        if (g) { a.href = '#' + g.id; a.querySelector('span').textContent = 'Ver las ' + g.mx29Count + ' promociones del día'; }
      });
    }

    // Cuenta regresiva del día seleccionado: "Empieza en", "Termina en" o "Venta finalizada"
    function tick() {
      const now = Date.now();
      if (days.some((_, k) => stateOf(k, now) !== sts[k])) {
        applyStates();
        // Si la persona no eligió un día, la sección pasa sola al día en curso o al próximo (por ejemplo a las 8:00 a.m.)
        if (!picked) { const k = defaultSel(); if (k !== sel) { select(k, false); return; } }
      }
      // Etiquetas de los banners (HOY, MAÑANA, HASTA LAS 8 A.M.…): cambian con el reloj aunque no cambie el estado
      const minute = Math.floor(now / 60000);
      if (minute !== lastMinute) { lastMinute = minute; slides.forEach((s, k) => { const el = s.querySelector('[data-mx29-status]'); if (el && days[k]) setStatus(el, days[k]); }); }
      const p = panels[sel], w = days[sel], box = p && p.querySelector('.xcd'); if (!box || !w) return;
      const st = sts[sel], target = st === 'next' ? w.start : w.end;
      const label = st === 'next' ? 'Empieza en' : st === 'today' ? 'Termina en' : 'Venta finalizada';
      box.classList.toggle('live', st === 'today'); box.classList.toggle('done', st === 'past');
      box.querySelector('.xcd-l').textContent = label;
      if (st === 'past') return;
      const s = Math.max(0, Math.floor((target - now) / 1000)), v = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
      box.querySelectorAll('.xcd-n i').forEach((el, k) => { const t = String(v[k]).padStart(2, '0'); if (el.textContent !== t) el.textContent = t; });
      box.setAttribute('aria-label', `${label} ${v[0]} días, ${v[1]} horas y ${v[2]} minutos`);
    }

    applyStates();
    const defaultSel = () => { let k = sts.indexOf('today'); if (k < 0) k = sts.indexOf('next'); return k < 0 ? n - 1 : k; };
    let picked = false, lastMinute = 0;
    sel = defaultSel();
    function select(k, scrollTab) {
      sel = (k + n) % n;
      slides.forEach((s, j) => s.classList.toggle('on', j === sel));
      tabs.forEach((b, j) => b.setAttribute('aria-selected', j === sel));
      panels.forEach((p, j) => { p.hidden = j !== sel; });
      const tr = panels[sel] && panels[sel].querySelector('.track'); if (tr) tr.scrollLeft = 0;
      if (scrollTab && tabs[sel]) { const bar = tabs[sel].parentElement; bar.scrollTo({ left: tabs[sel].offsetLeft - (bar.clientWidth - tabs[sel].offsetWidth) / 2, behavior: 'smooth' }); }
      tick();
      syncGrids();
    }
    tabs.forEach((b, k) => (b.onclick = () => { picked = true; select(k, true); }));
    const xb = sec.querySelector('.xb');
    sec.querySelector('.xa.prev').onclick = () => { picked = true; select(sel - 1, true); };
    sec.querySelector('.xa.next').onclick = () => { picked = true; select(sel + 1, true); };
    onSwipe(xb, (dir) => { picked = true; select(sel + dir, true); });
    sec.mx29Select = (date) => { const k = slides.findIndex((s) => s.dataset.mx29Date === (date || '').trim()); if (k >= 0) { picked = true; select(k, true); } };
    sec.mx29SelectSlide = (el) => { const k = slides.indexOf(el); if (k >= 0) { picked = true; select(k, true); } };
    sec.mx29Sync = () => syncGrids();
    select(sel, false);
    sec.__mx29timer = setInterval(tick, 1000);
  }

  /* ───── Carruseles de producto ───── */
  function initTracks(root) {
    root.querySelectorAll('.mx29-lp .track-wrap').forEach((w) => {
      if (w.__mx29) return; w.__mx29 = true;
      const t = w.querySelector('.track');
      w.querySelector('.t-btn.prev').onclick = () => t.scrollBy({ left: -t.clientWidth * 0.8, behavior: 'smooth' });
      w.querySelector('.t-btn.next').onclick = () => t.scrollBy({ left: t.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  /* ───── Footer: acordeones cerrados en móvil, abiertos en desktop ───── */
  const mqF = matchMedia('(max-width:820px)');
  const setAcc = () => document.querySelectorAll('.mx29-lp .js-acc').forEach((d) => { d.open = !mqF.matches; });
  mqF.addEventListener('change', setAcc);

  /* ───── Términos y condiciones del Botonazo (sección mx29-tyc) ─────
     Cualquier elemento con data-tyc abre la ventana; si la sección no está en la página, el link sigue su curso. */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.mx29-lp [data-tyc]'); if (!t) return;
    const d = document.querySelector('.mx29-lp dialog[data-mx29-tyc]'); if (!d) return;
    e.preventDefault(); e.stopPropagation();
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    document.documentElement.classList.add('mx29-nos');
    if (!d.__mx29) {
      d.__mx29 = true;
      const close = () => { if (typeof d.close === 'function') d.close(); else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); } };
      d.addEventListener('click', (ev) => { if (ev.target === d || ev.target.closest('[data-tyc-close]')) close(); });
      d.addEventListener('close', () => document.documentElement.classList.remove('mx29-nos'));
    }
  });

  /* ───── Tarjetas de colección: el botón lleva a la colección cuando el día está en curso ───── */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.mx29-lp [data-mx29-href]');
    if (!b || b.disabled) return;
    location.href = b.dataset.mx29Href;
  });

  /* ───── Carrito (Ajax Cart API + carrito lateral del tema) ───── */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.mx29-lp [data-mx29-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    const label = b.textContent;
    b.disabled = true; b.textContent = 'Agregando…';
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.mx29Add, quantity: 1 }] }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || '');
      b.textContent = 'Agregado ✓';
      // Respeta la acción del tema al agregar (settings.cart_action): drawer o mini carrito se actualizan; si no, va al carrito
      const ac = window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart;
      if (ac && (ac.cart_action === 'drawer' || ac.cart_action === 'mini_cart') && typeof ac.updateView === 'function') {
        try { ac.updateView(); if (ac.cart_action === 'drawer') ac.showDrawer(); } catch (_) {}
      } else { location.href = root + 'cart'; return; }
    } catch (err) {
      b.textContent = err.message && err.message.length < 70 ? err.message : 'No se pudo agregar';
    }
    setTimeout(() => { b.textContent = label; b.disabled = false; }, 2400);
  });

  /* ───── Arranque (y recarga de secciones en el editor de temas) ───── */
  function init(root) {
    root.querySelectorAll('[data-mx29-hero]').forEach(initHero);
    root.querySelectorAll('[data-mx29-home]').forEach(initHome);
    root.querySelectorAll('[data-mx29-grid]').forEach(initGrid);
    root.querySelectorAll('[data-mx29-exc]').forEach(initExc);
    const exc = document.querySelector('[data-mx29-exc]'); if (exc && exc.mx29Sync) exc.mx29Sync();
    initTracks(root);
    setAcc();
  }
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const h = e.target.querySelector('[data-mx29-hero]'); if (h && h.__mx29stop) h.__mx29stop();
    const x = e.target.querySelector('[data-mx29-exc]'); if (x && x.__mx29timer) clearInterval(x.__mx29timer);
    const hm = e.target.querySelector('[data-mx29-home]'); if (hm && hm.__mx29timer) clearInterval(hm.__mx29timer);
  });
  // En el editor: al seleccionar una sección de Promociones del día, se elige su día en la Venta exclusiva
  document.addEventListener('shopify:section:select', (e) => {
    const g = e.target.querySelector('[data-mx29-grid]'); if (!g) return;
    const exc = document.querySelector('[data-mx29-exc]'); if (exc && exc.mx29Select) exc.mx29Select(g.dataset.mx29Date);
    const r = g.closest('.mx29-lp'); if (r && r.hidden) r.hidden = false;
  });
  document.addEventListener('shopify:block:select', (e) => {
    const sec = e.target.closest('[data-mx29-exc]');
    if (sec && sec.mx29SelectSlide) sec.mx29SelectSlide(e.target);
  });
})();
